<template>
  <v-app id="registration-page">
      <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
    <v-content style="margin-bottom:150px">
      <header-p></header-p>
      <section id="registerForm" style="margin-top:30px">
        <v-layout style="padding-left:20px;padding-right:20px" v-if="!sended">
          <v-flex xs12 sm10 offset-sm1 md10 offset-md-1 offset-lg3 lg6>
            <v-card class="elevation-0">
              <v-toolbar class="q-orange-bk white--text">
                <div style="width:100%; justify-content: center; display:flex">
                  <h2 style="font-size:30px;font-weight:lighter;">{{getString('Registrazione')}}</h2>
                </div>
              </v-toolbar>
              <v-card-title primary-title>
                <div style="margin-left:10px">
                  <h3
                    class="headline mb-0"
                  >{{getString('Inviaci i tuoi dati per entrar subito a far parte del mondo di QuickBe, la registrazione è senza impegno e non vi è nessun obbligo di proseguimento!')}}</h3>
                  <div>
                    <b>{{getString(`N.B.`)}}</b>
                    {{getString(' alcuni campi sono obbligatori*')}}
                  </div>
                </div>
              </v-card-title>
              <v-form>
                <v-layout row wrap>
                  <v-stepper v-model="e1" style="width:100%">
                    <v-stepper-header>
                      <v-stepper-step
                        color="red lighten-2"
                        :complete="e1 > 1"
                        step="1"
                      >{{getString('Il tuo negozio')}}</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step
                        color="red lighten-2"
                        :complete="e1 > 2"
                        step="2"
                      >{{getString('Tu')}}</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step
                        color="red lighten-2"
                        :complete="e1 > 3"
                        step="3"
                      >{{getString('Altro (facoltativi)')}}</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step color="red lighten-2" step="4">{{getString('Completa')}}</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <v-card class="mb-5 elevation-0">
                          <v-layout row wrap>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="shop"
                                  :rules="nameRules"
                                  v-bind:label="getString('Nome del negozio')"
                                  v-bind:hint="getString('Il nome del negozio')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="shopAddress"
                                  :rules="nameRules"
                                  v-bind:label="getString('Indirizzo')"
                                  v-bind:hint="getString('L\'indirizzo del negozio comprensivo di numero')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg3 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="shopCity"
                                  :rules="nameRules"
                                  v-bind:label="getString('Città')"
                                  v-bind:hint="getString('La città')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg3 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="cap"
                                  :rules="capRules"
                                  v-bind:label="getString('CAP')"
                                  v-bind:hint="getString('Il codice di avviamento postale')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="prov"
                                  v-bind:label="getString('Provincia')"
                                  v-bind:hint="getString('La provincia')"
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-card>
                        <v-btn
                          class="q-orange-bk q-text-whitesmoke"
                          :disabled="!validStep1"
                          @click="e1 = 2"
                        >{{getString('Continua')}}</v-btn>
                      </v-stepper-content>

                      <v-stepper-content step="2">
                        <v-card class="mb-5">
                          <v-layout row wrap>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="name"
                                  :rules="nameRules"
                                  v-bind:label="getString('Nome')"
                                  v-bind:hint="getString('Il tuo nome')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="surname"
                                  :rules="nameRules"
                                  v-bind:label="getString('Cognome')"
                                  v-bind:hint="getString('Il tuo cognome')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="email"
                                  :rules="emailRules"
                                  label="E-mail"
                                  v-bind:hint="getString('Il campo deve essere un indirizzo email valido, per esempio: elcarro@carriage.xyz')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="phone"
                                  v-bind:label="getString('Telefono')"
                                  v-bind:hint="getString('Il tuo telefono (verrà usato solo per contattarti una volta inerente alla registrazione)')"
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-card>
                        <v-btn
                          class="q-orange-bk q-text-whitesmoke"
                          :disabled="!validStep2"
                          @click="e1 = 3"
                        >{{getString('Continua')}}</v-btn>
                        <v-btn class="q-color" @click="e1 = 1" flat>{{getString('Indietro')}}</v-btn>
                      </v-stepper-content>

                      <v-stepper-content step="3">
                        <v-card class="mb-5">
                          <v-layout row wrap>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="rsocial"
                                  :rules="nameRules"
                                  v-bind:label="getString('Ragione sociale')"
                                  v-bind:hint="getString('Il nome ufficiale della tua attività')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="fatAddress"
                                  :rules="nameRules"
                                  v-bind:label="getString('Indirizzo')"
                                  v-bind:hint="getString('L\'indirizzo completo per la fatturazione')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  :counter="16"
                                  solo
                                  v-model="cf"
                                  :rules="cfRules"
                                  label="Codice Fiscale"
                                  v-bind:hint="getString('Il tuo codice fiscale')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <v-text-field
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="piva"
                                  :rules="pivaRules"
                                  v-bind:label="getString('P.Iva')"
                                  v-bind:hint="getString('La partita iva della tua attività')"
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 sm12 lg6 md12>
                              <v-container>
                                <v-textarea
                                  solo
                                  v-bind:disabled="sended"
                                  v-bind:label="getString('Eventuali note')"
                                  v-model="message"
                                ></v-textarea>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-card>
                        <v-btn
                          class="q-orange-bk q-text-whitesmoke"
                          @click="e1 = 4"
                        >{{getString('Continua')}}</v-btn>
                        <v-btn class="q-color" @click="e1 = 2" flat>{{getString('Indietro')}}</v-btn>
                      </v-stepper-content>
                      <v-stepper-content step="4">
                        <v-card class="mb-5">
                          <v-layout wrap row>
                            <v-flex xs12 sm12 md12 lg12>
                              <v-container>
                                <p
                                  v-html="getString(`Qui trovi i <a href='/legal/tec' target='_new'>Termini e Condizioni</a> per il trattamento dati. Leggili ed accetta per inviare il messaggio in piena consapevolezza.`)"
                                ></p>
                                <v-checkbox
                                  :label="getString('Accetto')"
                                  v-model="accept"
                                  v-bind:disabled="sended"
                                ></v-checkbox>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 md12 lg6 sm12>
                              <v-container>
                                <label>{{getString('Se ti è stato fornito un codice presentazione, inseriscilo qui.')}}</label>
                                <v-text-field
                                  color="#212121"
                                  :rules="cScontRule"
                                  :placeholder="getString('Codice di presentazione')"
                                  v-bind:disabled="sended"
                                  solo
                                  v-model="presCode"
                                  label="getString('Codice Presentazione')"
                                  :hint="getString('Il codice è in formato: AAA-0000')"
                                  required
                                ></v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 sm12 md6 lg6>
                              <v-container>
                                <label style="min-height: 42px; display:block">{{getString('Per cortesia, indica come ci hai conosciuto')}}</label>
                                <v-select
                                  solo
                                  color="#212121"
                                  v-bind:disabled="sended"
                                  v-model="select"
                                  :items="knowledge"
                                  v-bind:label="getString('Come ci hai conosciuto?')"
                                ></v-select>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-card>
                        <v-btn
                          class="q-orange-bk q-text-whitesmoke"
                          @click="sendForm"
                          :disabled="!validStep3"
                        >{{getString('Registrati')}}</v-btn>
                        <v-btn class="q-color" @click="e1 = 3" flat>{{getString('Indietro')}}</v-btn>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-layout>
              </v-form>
              <v-card-actions>
                <!-- <v-container>
                                <v-btn v-if="!sended" @click='sendForm()' class="q-orange">{{getString('Invia')}}</v-btn>
                </v-container>-->
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout column v-if="sended">
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="q-headline">{{getString('Grazie per aver scelto QuickBe!')}}</h2>
              <span
                class="subheading"
              >{{getString(`Verrai contattato al più presto da un nostro incaricato per il resto.`)}}</span>
              <v-container>
                <v-btn
                  class="q-orange"
                  @click="$router.push({path:'/'})"
                >{{getString('Torna a QuickBe')}}</v-btn>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
      </section>
    </v-content>
    <v-footer dark height="auto" class=".footer">
      <v-card class="flex" flat tile>
        <v-card-title class="q-orange-bk">
          <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
          <v-spacer></v-spacer>
          <v-btn
            v-for="icon in icons"
            :key="icon.ic"
            class="mx-3"
            dark
            icon
            @click="navigate(icon.url)"
          >
            <v-icon size="24px">{{ icon.ic }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="grey darken-3 justify-center" style="text-align:center">
          &copy; 2018 - &copy;{{(new Date()).getFullYear()}} — &nbsp;
          <strong>Dew Studio</strong> &nbsp; — &nbsp;
          <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
          <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
          <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
          <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
          <router-link to="/admin/login">{{getString('Portale')}}</router-link>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card class="q-whitesmoke-bk black--text" dark>
        <v-card-text>
          {{getString('Invio in corso')}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" hide-overlay persistent width="300">
      <v-card class="green lighten-3" dark>
        <v-card-text>
          <h4>{{getString('Inviato con successo')}}</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" hide-overlay persistent width="300">
      <v-card class="red lighten-1" dark>
        <v-card-text>
          <h4>{{getString('Errore nell\'invio, riprova più tardi')}}</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogErrorMissing" hide-overlay persistent width="300">
      <v-card class="red lighten-1" dark>
        <v-card-text>
          <h4>{{getString('Campi mancanti')}}</h4>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import ajax from "../../ajax";
import Utils from "../../utils";
import HeaderP from "./Header";
import CookieLaw from "vue-cookie-law";
let ut = new Utils();
export default {
  name: "Register",
  mounted: function() {
    this.myPixel = this.initPixel(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');    
    this.myPixel('init', '551676001909516');
    this.myPixel('track', 'PageView');
  },
  components: {
    HeaderP,
    CookieLaw
  },
  computed: {
    pivaRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => /[0-9]+/.test(v) || this.getString("P. Iva non valida")
      ];
    },
    cScontRule: function() {
      return [
        v =>
          /^[A-Z]{3}\-[0-9]{6}$|^$/g.test(v) ||
          this.getString('Codice sconto non valido. Usa il formato: "AAA-000000"')
      ];
    },
    cfRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateCF(v) || this.getString("Codice fiscale non valido")
      ];
    },
    capRules: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    nameRules: function() {
      return [v => !!v || this.getString("Campo richiesto")];
    },
    emailRules: function() {
      return [
        v => !!v || this.getString("Campo richiesto"),
        v => ut.ValidateEmail(v) || this.getString("Email non valida")
      ];
    },
    knowledge: function() {
      return [
        {
          text: this.getString("Passaparola"),
          value: "w"
        },
        {
          text: this.getString("Motore di ricerca"),
          value: "se"
        },
        {
          text: this.getString("Facebook"),
          value: "fb"
        },
        {
          text: this.getString("Instagram"),
          value: "in"
        },
        {
          text: this.getString("Altro"),
          value: "ot"
        }
      ];
    },
    validStep1: function() {
      return (
        this.shop !== "" &&
        this.shopAddress !== "" &&
        this.cap !== "" &&
        this.shopCity !== "" &&
        this.prov !== ""
      );
    },
    validStep2: function() {
      return (
        ut.ValidateEmail(this.email) && this.name !== "" && this.surname !== ""
      );
    },
    validStep3: function() {
      return (
        this.select != null && this.accept == true
      );
    },
    valid: function() {
      return (
        ut.ValidateEmail(this.email) &&
        this.name !== "" &&
        this.surname !== "" &&
        this.accept &&
        this.select !== null &&
        this.shop !== "" &&
        this.shopAddress !== "" &&
        this.cap !== "" &&
        this.shopCity !== "" &&
        this.prov !== "" &&
        this.rsocial !== "" &&
        this.fatAddress !== "" &&
        /[a-z]{6}\d{2}[abcdehlmprst]\d{2}[a-z]\d{3}[a-z]/i.test(this.cf) &&
        /[0-9]+/.test(this.piva) &&
        /^[A-Z]{3}\-[0-9]{6}$|^$/g.test(this.cScontRule)
      );
    }
  },
  watch: {
    cf: function(n, o) {
      this.cf = this.cf.toUpperCase();
    }
  },
  data: () => {
    return {
      myPixel: null,
      e1: 0,
      presCode: "",
      dialog: false,
      sended: false,
      dialogError: false,
      dialogSuccess: false,
      dialogErrorMissing: false,
      icons: [
        { ic: "fab fa-facebook", url: "https://www.facebook.com/QuickBeApp/" },
        { ic: "fab fa-instagram", url: "https://www.instagram.com/quickbeapp/" }
      ],
      name: "",
      surname: "",
      email: "",
      phone: "",
      shop: "",
      shopAddress: "",
      shopCity: "",
      cap: "",
      prov: "",
      rsocial: "",
      fatAddress: "",
      cf: "",
      piva: "",
      message: "",
      select: null,
      accept: ""
    };
  },
  methods: {
    initPixel: function(f, b, e, v, n, t, s) {
      if (f.fbq) return f.fbq;
      n = f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
      return f.fbq;
    },
    navigate: function(url) {
      window.open(url);
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    sendForm: function() {
      let self = this;
      if (this.validStep1 && this.validStep2) {
        this.dialog = true;
        ajax.axios
          .post(
            ajax.baseUrl() + "/register",
            // params
            {
              name: this.name,
              surname: this.surname,
              how: this.select,
              email: this.email,
              message: this.message,
              tel: this.phone,
              shopName: this.shop,
              shopCity: this.shopCity,
              shopAddress: this.shopAddress,
              shopCap: this.cap,
              shopProvincia: this.prov,
              invoiceDen: this.rsocial,
              invoiceAddress: this.fatAddress,
              invoiceCf: this.cf,
              invoicePIva: this.piva,
              cs: this.presCode
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers, self.$store);
            self.dialog = false;
            self.dialogSuccess = true;
            self.sended = true;
            setTimeout(function() {
              self.dialogSuccess = false;
              self.myPixel('track', 'CompleteRegistration');
            }, 4000);
          })
          .catch(function(error) {
            self.dialog = false;
            self.dialogError = true;
            setTimeout(function() {
              self.dialogError = false;
            }, 4000);
          });
      } else {
        self.dialog = false;
        self.dialogErrorMissing = true;
        setTimeout(function() {
          self.dialogErrorMissing = false;
        }, 2000);
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/frontend/Register.vue